import store from "../../../state/store";

export const tokenUrl = `${
  store.getState().ssoUrl
}/clinvar-submission/auth/access-token/`;

export const submissionUrl = `${
  store.getState().apiUrl
}/clinvar-submission/api/classify_variant/`;
